export class HistogrammeRendement {
    static jsonMap = {
        libelleGroupeVarietal: 'libelleGroupeVarietal',
        rendementEntreprise: 'rendementEntreprise',
        rendementDepartemental: 'rendementDepartemental',
        rendementNational: 'rendementNational'
    };

    libelleGroupeVarietal: string = undefined;
    rendementEntreprise: number = undefined;
    rendementDepartemental: number = undefined;
    rendementNational: number = undefined;
}
